export default function IconPause({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <g clipPath="url(#clip0_3226_13944)">
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill="white"
                    fillOpacity="0.2"
                />
                <path
                    d="M12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57969 18.4203 0.375 12 0.375C5.57969 0.375 0.375 5.57969 0.375 12C0.375 18.4203 5.57969 23.625 12 23.625Z"
                    stroke="white"
                    strokeWidth="0.75"
                />
                <path
                    d="M9.1041 17.1C8.63437 17.1 8.25 16.7156 8.25 16.2459V8.3541C8.25 7.88437 8.63437 7.5 9.1041 7.5C9.57382 7.5 9.9582 7.88437 9.9582 8.3541V16.2459C9.9582 16.7156 9.57382 17.1 9.1041 17.1Z"
                    fill="white"
                />
                <path
                    d="M14.9375 17.1C14.4677 17.1 14.0834 16.7156 14.0834 16.2459V8.3541C14.0834 7.88437 14.4677 7.5 14.9375 7.5C15.4073 7.5 15.7916 7.88437 15.7916 8.3541V16.2459C15.7916 16.7156 15.4073 17.1 14.9375 17.1Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_3226_13944">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
